import React from 'react';
import { motion } from 'framer-motion';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';

const ContactForm = () => {
  // Form validation schema using Yup
  const validationSchema = Yup.object({
    name: Yup.string().required('Name is required'),
    email: Yup.string().email('Invalid email format').required('Email is required'),
    phone: Yup.string()
      .matches(/^[0-9]{10}$/, 'Phone number must be 10 digits')
      .required('Phone is required'),
    subject: Yup.string().required('Subject is required'),
    message: Yup.string().required('Message is required')
  });

  // Initial values for the form
  const initialValues = {
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  };

  // Submit handler
  const handleSubmit = (values) => {
    console.log('Form submitted:', values);
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.6 }}
      className="py-16 bg-light"
    >
      <div className="container py-5">
        <h3 className="text-center text-warning mb-4">Leave a Message</h3>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ touched, errors }) => (
            <Form>
              <div className="row">
                <div className="col-md-6">
                  <Field
                    type="text"
                    className={`form-control mb-2 ${touched.name && errors.name ? 'is-invalid' : ''}`}
                    name="name"
                    placeholder="Name"
                  />
                  <ErrorMessage
                    name="name"
                    component="div"
                    className="invalid-feedback"
                  />
                </div>
                <div className="col-md-6">
                  <Field
                    type="email"
                    className={`form-control mb-2 ${touched.email && errors.email ? 'is-invalid' : ''}`}
                    name="email"
                    placeholder="Email"
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="invalid-feedback"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <Field
                    type="tel"
                    className={`form-control mb-2 ${touched.phone && errors.phone ? 'is-invalid' : ''}`}
                    name="phone"
                    placeholder="Phone"
                  />
                  <ErrorMessage
                    name="phone"
                    component="div"
                    className="invalid-feedback"
                  />
                </div>
                <div className="col-md-6">
                  <Field
                    type="text"
                    className={`form-control mb-2 ${touched.subject && errors.subject ? 'is-invalid' : ''}`}
                    name="subject"
                    placeholder="Subject"
                  />
                  <ErrorMessage
                    name="subject"
                    component="div"
                    className="invalid-feedback"
                  />
                </div>
              </div>

              <div className="mb-4">
                <Field
                  as="textarea"
                  className={`form-control ${touched.message && errors.message ? 'is-invalid' : ''}`}
                  rows={5}
                  name="message"
                  placeholder="Message"
                />
                <ErrorMessage
                  name="message"
                  component="div"
                  className="invalid-feedback"
                />
              </div>

              <div className="text-center">
                <button type="submit" className="btn btn-primary px-4 rounded-0">
                  Submit
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </motion.div>
  );
};

export default ContactForm;
